// src/Navabr/Pages/Contact.js
import React from "react";
import "./Contact.css";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="contact-page">

      {/* HERO SECTION */}
      <section className="contact-hero">
        <div className="contact-hero-left">
          <span className="contact-pill">Contact Us</span>
          <h1 className="contact-hero-title">
            Let&apos;s talk about your next <span>software project</span>.
          </h1>
          <p className="contact-hero-subtitle">
            Share a few details and we&apos;ll get back to you with next steps,
            timelines, and how we can help.
          </p>

          <div className="contact-hero-badges">
            <span>✅ Product &amp; MVP builds</span>
            <span>✅ Web &amp; Mobile Apps</span>
            <span>✅ Long-term tech partner</span>
          </div>
        </div>

        {/* RIGHT SIDE CARDS */}
        <div className="contact-hero-right">

          {/* PHONE CARD */}
          <div className="contact-info-card">
            <div className="contact-info-icon">
              <FaPhoneAlt />
            </div>
            <h3>Call / WhatsApp</h3>
            <p>
              <a href="tel:+918983971671" className="contact-link">
                +91 8983971671
              </a>
            </p>
            <p>
              <a href="tel:+917276445893" className="contact-link">
                +91 7276445893
              </a>
            </p>
            <span className="contact-info-tag">
              Mon – Sat · 10:00 AM – 7:00 PM
            </span>
          </div>

          {/* EMAIL CARD */}
          <div className="contact-info-card">
            <div className="contact-info-icon">
              <FaEnvelope />
            </div>
            <h3>Email</h3>
            <p>
              <a
                href="mailto:info@aazirasolutions.com"
                className="contact-link"
              >
                info@aazirasolutions.com
              </a>
            </p>
            <span className="contact-info-tag">We reply within 24 hours</span>
          </div>

        </div>
      </section>

      {/* FORM SECTION */}
      <section className="contact-main new-contact-section">

        {/* LEFT SIDE FORM */}
        <div className="contact-form-card">
          <h2 className="contact-form-title">Tell us about your project</h2>
          <p className="contact-form-subtitle">
            A quick brief helps our solution experts get back to you with the
            right plan.
          </p>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-row">
              <div className="contact-input">
                <label>Full Name</label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="contact-input">
                <label>Work Email</label>
                <input
                  type="email"
                  placeholder="you@company.com"
                  required
                />
              </div>
            </div>

            <div className="contact-row">
              <div className="contact-input">
                <label>Phone / WhatsApp</label>
                <input type="tel" placeholder="+91-XXXXXXXXXX" />
              </div>

              <div className="contact-input">
                <label>Project Type</label>
                <select defaultValue="">
                  <option value="" disabled>
                    Select project type
                  </option>
                  <option>Web Application / Portal</option>
                  <option>Mobile App (Android / iOS)</option>
                  <option>Custom ERP / CRM</option>
                  <option>AI &amp; Automation</option>
                  <option>UI/UX Design</option>
                  <option>Support &amp; Maintenance</option>
                </select>
              </div>
            </div>

            <div className="contact-input full">
              <label>Project Brief</label>
              <textarea
                rows="4"
                placeholder="Share your idea, goals, challenges, and any important details..."
                required
              />
            </div>

            <div className="contact-submit-section">
              <button type="submit" className="contact-submit-btn">
                Submit Enquiry
              </button>
              <p className="contact-response">
                ⏱ We usually respond within <strong>1 business day</strong>.
              </p>
            </div>
          </form>
        </div>

        {/* RIGHT SIDE PANEL */}
        <div className="contact-side-card">
          <h3 className="side-title">Why teams work with us</h3>

          <ul className="side-list">
            <li>⚡ Clean, scalable codebase</li>
            <li>🎨 Modern UI / UX for web &amp; mobile</li>
            <li>🛠 Clear communication &amp; predictable delivery</li>
          </ul>

          <div className="side-info-box">
            <p className="info-title">Already have a brief or document?</p>
            <p className="info-sub">
              Paste the key points in the message box or email us at:
              <br />
              <a
                href="mailto:info@aazirasolutions.com"
                className="contact-link"
              >
                info@aazirasolutions.com
              </a>
            </p>
          </div>
        </div>

      </section>
    </div>
  );
}
